/*
===============================================================================================================
                                 Copyright 2022-2026, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import { omit } from 'lodash';
import compileChangeObject from './compile-change-object';

export default (changeArray, productName) => {
  let changeObject = {};
  const fieldsToOmit = [
    'incomeRange', 'turnoverRange', 'industry', 'firstName', 'lastName',
    'collectionSolutionRequired', 'collectionServicesSelected', 'platformPartner',
    'eParcel', 'myPostBusiness', 'startrackPremium',
  ];

  changeObject = compileChangeObject(changeArray, productName);

  if (changeObject.applicant?.returnsPortalInternational) {
    changeObject.applicant.customersToUse = true;
  }

  if (changeObject.applicant?.firstName && changeObject.applicant?.lastName) {
    changeObject.applicant.contactName = `${changeObject.applicant?.firstName} ${changeObject.applicant?.lastName}`;
  }
  changeObject.applicant = omit(changeObject.applicant, [...fieldsToOmit]);
  return changeObject;
};
